{
  "notifications": {
    "success": {
      "PIN_ORGANIZATION_SUCCESS": {
        "description": "Organization has been pinned to the dashboard successfully"
      },
      "UNPIN_ORGANIZATION_SUCCESS": {
        "description": "Organization has been unpinned from the dashboard successfully"
      },
      "SUB_AUDIT_CREATION_SUCCESS": {
        "description": "Sub-audit has been created successfully"
      },
      "SUB_AUDIT_EDITION_SUCCESS": {
        "description": "Sub-audit has been updated successfully"
      },
      "SUB_AUDIT_COMMENT_CREATION_SUCCESS": {
        "description": "Comment has been added to the sub-audit successfully"
      },
      "SUB_AUDIT_COMMENT_EDITION_SUCCESS": {
        "description": "Comment has been updated successfully"
      },
      "SUB_AUDIT_COMMENT_DELETION_SUCCESS": {
        "description": "Comment has been deleted successfully"
      }
    }
  }
}
